import React from 'react'
import { Button, Text, Title, Space, Paper } from '@mantine/core'
import { useMediumScreen } from '@/hooks'

const AirdropError: React.FC = () => {
  const { isMediumScreen } = useMediumScreen()

  const handleRefetch = () => {
    window.location.reload()
  }

  return (
    <Paper p="md" shadow="lg" withBorder sx={{ textAlign: 'center' }}>
      <Title order={4} sx={(t) => ({ color: t.colors.gray[9], lineHeight: 1 })}>
        Meep morp. Zeep.
      </Title>

      <Space h="sm" />

      <Text color="gray" inline>
        We can't seem to fetch your airdrop data.
      </Text>

      <Space h="md" />

      <Button fullWidth={!isMediumScreen} onClick={handleRefetch}>
        Try again
      </Button>
    </Paper>
  )
}

export { AirdropError }
